import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadIncludeFilterConfig } from '../../../configs/lead-include-filter-config';

export const LeadIncludeFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Include'
      config={leadIncludeFilterConfig}
    />
  );
};
